import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DbmEditComponent } from './dbm-edit.component';

@NgModule({
    imports: [CommonModule],
    declarations: [DbmEditComponent],
    entryComponents: [DbmEditComponent],
    exports: [DbmEditComponent]
})
export class DbmEditModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-edit/dbm-edit.module.ts